export enum ApplicationSettingsType {
    DocumentLocal = 1,
    DocumentCentral = 2,
    MediaBankLocal = 3,
    MediaBankCentral = 4,
    PostLocal = 5,
    PostCentral = 6,
    CoreCentral = 7,
    Appearance = 8,
    CoreLocal = 9,
    Tag = 10,
    StatisticsLocal = 11,
    StatisticsCentral = 12,
    ConfidentialAgreement = 17,
    Email = 18,
    BillingLocal = 19,
    BillingCentral = 20,
    SMS = 21,
    ChecklistLocal = 22,
    ChecklistCentral = 23,
    Forum = 24,
    CheckListReports = 25,
    // 26 and 27 reserved. please do not use them
    ADIntegration = 28,
    Statistics2 = 29,
    // 30 and 31 reserved. please do not use them
    FormLocal = 32,
    FormCentral = 33,
    FormReports = 34,
    // 35 and 36 reserved. please do not use them
    Task = 37,
    // 38 and 39 reserved. please do not use them
    ForumAdmin = 40,
    // 41 and 42 reserved. please do not use them
    Chat = 43,
    // 44 and 45 reserved. please do not use them
    Personalkollen = 46,
    BalooELearning = 47,

    CoreGlobal = 48,
    PostGlobal = 49,
    FormGlobal = 50,
    DocumentGlobal = 51,
    MediaBankGlobal = 52,
    ChecklistGlobal = 53,

    Planday = 54,

    ChecklistV2Local = 55,
    ChecklistV2Central = 56,
    ChecklistV2Global = 57,

    ChecklistV2Reports = 58,
    // 59 and 60 reserved. please do not use them

    ChecklistV2AuditLocal = 61,
    ChecklistV2AuditCentral = 62,
    ChecklistV2AuditGlobal = 63,

    ChecklistV2AuditReports = 64,
    // 65 and 66 reserved. please do not use them

    TaskV2Local = 67,
    TaskV2Central = 68,
    TaskV2Global = 69,

    TaskV2Reports = 70,
    // 71 and 72 reserved. please do not use them

    LoginReminder = 73,

    OnboardingLocal = 74,
    OnboardingCentral = 75,
    OnboardingGlobal = 76,

    OnboardingReports = 77,
    // 78 and 79 reserved. please do not use them

    CustomFranchiseIntranetUpgrade = 103,
    CustomerBilling = 105,
    // WordImport = 106
}

export enum ApplicationSettingsTypeGroup {
    Core = 1,
    Document,
    MediaBank,
    Post,
    Appearance,
    Statistics,
    Task,
    TaskV2,
    Email,
    SMS,
    Forum,
    Chat,
    Checklist,
    ChecklistV2,
    ChecklistV2Audit,
    Form,
    Upgrade,
    CustomerBilling,
    Tag,
    Personalkollen,
    ConfidentialAgreement,
    Billing,
    ADIntegration,
    BalooELearning,
    Planday,
    LoginReminder,
    Onboarding,
    Other,
}
